WiseMetering.Collection.SiteDocuments = WiseMetering.Collection.extend({
    hasOrganization: true,
    url: '/site_documents',
});
